import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";

export default function useAuthWatcher(protectedRoutes = []) {
  const navigate = useNavigate();
  const location = useLocation();
  const timeoutRef = useRef(null);
  const onProtectedRoute = useRef(false);

  useEffect(() => {
    const token = sessionStorage.getItem("token");

    const logout = () => {
      sessionStorage.removeItem("token");
      localStorage.setItem("sessionExpired", "true");
      navigate("/login", { replace: true });
    };

    const decodePayload = (t) => {
      try {
        const b64 = t.split(".")[1].replace(/-/g, "+").replace(/_/g, "/");
        const pad = b64.length % 4 ? b64 + "=".repeat(4 - (b64.length % 4)) : b64;
        return JSON.parse(atob(pad));
      } catch {
        return null;
      }
    };

    // 1️⃣ Token expiration
    if (token) {
      const payload = decodePayload(token);
      const exp = payload?.exp;
      if (exp) {
        const msLeft = exp * 1000 - Date.now();
        if (msLeft <= 0) logout();
        else timeoutRef.current = setTimeout(logout, msLeft + 500);
      }
    }

    // 2️⃣ Detect leaving protected routes
    const isProtected = protectedRoutes.some((r) =>
      location.pathname.startsWith(r)
    );

    if (onProtectedRoute.current && !isProtected && token) {
      // user left protected route → logout
      logout();
    }

    // Update ref for next check
    onProtectedRoute.current = isProtected;

    // 3️⃣ Detect logout from other tabs
    const handleStorage = (e) => {
      if (e.key === "sessionExpired" && e.newValue === "true") logout();
    };
    window.addEventListener("storage", handleStorage);

    return () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
      window.removeEventListener("storage", handleStorage);
    };
  }, [location.pathname, navigate, protectedRoutes]);
}
